import { TableRow, TableCell } from '@mui/material';
import { ListWorkPackageDto } from '@codefluegel/zeta-change-typescript-client';
import useWorkPackageName from '../../hooks/useWorkPackageName';
import { formatNumber } from '../../utils/getTotalTime';

type Props = {
  wp: ListWorkPackageDto;
  phaseName: string;
  hourlyRate: number;
};

const WorkPackageRow = ({ wp, phaseName, hourlyRate }: Props) => {
  const workPackageName = useWorkPackageName(wp);

  return (
    <TableRow key={wp.navPhasePspId}>
      <TableCell component="th" scope="row">
        {`${phaseName || ''} — ${workPackageName} — ${wp.workPackageNo}`}
      </TableCell>
      <TableCell align="right">{hourlyRate}</TableCell>
      <TableCell align="right">{wp.hours}</TableCell>
      <TableCell align="right">
        {formatNumber((wp.hours || 0) * (hourlyRate || 0))}
      </TableCell>
    </TableRow>
  );
};

export default WorkPackageRow;
